define('gameInterfaces/gameInterfacesComposition',['underscore', 'config/composition'], function (_, composition) {

    var gameInterfacesComposition = _.cloneDeep(composition.get());

    gameInterfacesComposition.params.shellViewModelServiceId = 'gameInterfacesShellViewModel';

    delete gameInterfacesComposition.services.abTesting.extras;
    delete gameInterfacesComposition.services.contentPreloader.extras;
    delete gameInterfacesComposition.services.emailVerification.extras;
    delete gameInterfacesComposition.services.metaData.extras;
    delete gameInterfacesComposition.services.modals.extras;
    delete gameInterfacesComposition.services.startMandatoryMessages.extras;
    delete gameInterfacesComposition.services.tacVersionListener.extras;
    delete gameInterfacesComposition.services.trackDeviceInfo.extras;

    gameInterfacesComposition.services = _.assign(gameInterfacesComposition.services, {
        routing: {
            module: 'gameInterfaces/gameInterfacesRouting',
            init: 'factory',
            args: [
                '@navigation',
                'publish:onNavigationComplete'
            ],
            extras: [
                {
                    subscribe: {
                        afterAppStart: 'afterAppStart'
                    }
                }
            ]
        },

        gameInterfacesShellViewModel: {
            module: 'gameInterfaces/GameInterfacesShell'
        },

        microgamingGameInterfaceViewModel: {
            module: 'gameInterfaces/pages/MicrogamingGameInterface',
            args: ['@RealityCheckViewModel']
        },

        netentGameInterfaceViewModel: {
            module: 'gameInterfaces/pages/NetEntGameInterface',
            args: ['LOG', '@RealityCheckViewModel']
        },

        playNGoGameInterfaceViewModel: {
            module: 'gameInterfaces/pages/PlayNGoGameInterface',
            args: ['@RealityCheckViewModel', '@navigation']
        },

        quickspinGameInterfaceViewModel: {
            module: 'gameInterfaces/pages/QuickspinGameInterface',
            args: ['@RealityCheckViewModel', '@navigation']
        }
    });

    return gameInterfacesComposition;

});

